import { render, staticRenderFns } from "./EnterpriseRoute.vue?vue&type=template&id=b2fa6d38&scoped=true"
import script from "./EnterpriseRoute.vue?vue&type=script&lang=js"
export * from "./EnterpriseRoute.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseRoute.vue?vue&type=style&index=0&id=b2fa6d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fa6d38",
  null
  
)

export default component.exports